import * as Actions from '../actions';

const initialState = [];

const accountReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_ACCOUNTS: {
			return {
				...state,
				accounts: action.payload
			};
		}

		case Actions.GET_DETAILS_ACCOUNTS: {
			return {
				...state,
				account: action.payload
			};
		}

		case Actions.GET_ACCOUNTS_CLUSTERS: {
			return {
				...state,
				accountsClusters: action.payload
			};
		}

		case Actions.GET_DETAILS_CLUSTERS: {
			return {
				...state,
				accountsDetailsClusters: action.payload
			};
		}

		case Actions.START_TIME: {
			return {
				...state,
				startTime: action.payload
			};
		}

		case Actions.END_TIME: {
			return {
				...state,
				endTime: action.payload
			};
		}

		default: {
			return state;
		}
	}
};

export default accountReducer;
